module.exports = __webpack_public_path__ + "static/scale-model-of-national-mustard-museum-in-madison-wisconsin-81c4caf3d01c70e266c8e241c2d38e3b.png";